// state
const state = {
    estado: false,
    indeterminate: true,
    msj: 'Por favor aguarde...',
    tit: 'Progreso',
    porcent: 0
};

// mutations
const mutations = {
    show(state, payload) {
        state.estado = true;
        state.indeterminate = (payload && payload.indeterminate) ? payload.indeterminate : false;
        state.msj = (payload && payload.msj) ? payload.msj : 'Por favor aguarde...';
        state.tit = (payload && payload.tit) ? payload.tit : 'Progreso...';
    },
    hide(state) {
        state.estado = false;
        state.indeterminate = true;
        state.msj = '';
        state.tit = '';
        state.porcent = 0;
    },
    porcent(state, payload) {
        state.porcent = payload.porcent;
        state.msj = (payload && payload.msj) ? payload.msj : 'Por favor aguarde...';
    }
};

// actions
const actions = {
    progresoShow({commit}, payload) {
        commit('show', payload)
    },
    progresoPorcent({commit}, payload) {
        commit('porcent', payload)
    },
    progresoHide({commit}) {
        commit('hide')
    }
};

// getters
const getters = {
    progresoEstado: state => state.estado,
    indeterminate: state => state.indeterminate,
    progresoMsj: state => state.msj,
    progresoTit: state => state.tit,
    progresoPorcent: state => state.porcent,
};

/*
|--------------------------------------------------------------------------
| Export the module
|--------------------------------------------------------------------------
*/
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/progreso.js